import { forwardRef } from 'react';
import type { SVGProps } from 'react';

export type SvgWrapperProps = Omit<SVGProps<SVGSVGElement>, 'xmlns' | 'ref'> & {
  /** null means no meaningful title (decorative icon) */
  title: string | null;
};

export const SvgWrapper = forwardRef<SVGSVGElement, SvgWrapperProps>(
  ({ children, title, ...props }, ref) => (
    <svg
      ref={ref}
      xmlns='http://www.w3.org/2000/svg'
      role={title === null ? 'graphics-symbol' : undefined}
      {...props}
    >
      {title !== null && <title>{title}</title>}
      {children}
    </svg>
  ),
);

SvgWrapper.displayName = 'SvgWrapper';
